import useProtoMethod from "./useProtoMethod";
import {
  ListSystemSchedulesRequest,
  ListSystemSchedulesResponse,
  CreateSystemScheduleRequest,
  CreateSystemScheduleResponse,
  UpdateSystemScheduleRequest,
  UpdateSystemScheduleResponse,
  ExecuteSystemScheduleRequest,
  ExecuteSystemScheduleResponse,
} from "protogen/scheduling_service_pb";

const useListSystemSchedules = (
  callback?: (r: ListSystemSchedulesResponse) => void,
) => {
  return useProtoMethod<
    ListSystemSchedulesRequest,
    ListSystemSchedulesResponse
  >("ListSystemSchedules", ListSystemSchedulesResponse, { callback });
};

const useCreateSystemSchedule = (
  callback?: (r: CreateSystemScheduleResponse) => void,
) => {
  return useProtoMethod<
    CreateSystemScheduleRequest,
    CreateSystemScheduleResponse
  >("CreateSystemSchedule", CreateSystemScheduleResponse, { callback });
};

const useUpdateSystemSchedule = (
  callback?: (r: UpdateSystemScheduleResponse) => void,
) => {
  return useProtoMethod<
    UpdateSystemScheduleRequest,
    UpdateSystemScheduleResponse
  >("UpdateSystemSchedule", UpdateSystemScheduleResponse, { callback });
};

const useExecuteSystemSchedule = (
  callback?: (r: ExecuteSystemScheduleResponse) => void,
) => {
  return useProtoMethod<
    ExecuteSystemScheduleRequest,
    ExecuteSystemScheduleResponse
  >("ExecuteSystemSchedule", ExecuteSystemScheduleResponse, { callback });
};

export {
  useListSystemSchedules,
  useCreateSystemSchedule,
  useUpdateSystemSchedule,
  useExecuteSystemSchedule,
};
